<template>
    <div class="alternative-articles" :class="[stackRow ? 'stack-row' : '']">
        <div v-for="(alternative, idx) in fetchAlternativeArticles(alternatives)" :key="idx" class="alternative-article-wrapper" :class="[stackRow ? 'stack-row' : '']">
            <div v-if="!hasRead(alternative.slug)" class="publisher">
                <img v-if="alternative.publisher" :src="alternative.publisher.icon"/>
            </div> 
            <div v-else>
                <status :slug="alternative.slug"></status>
            </div>
            <p class="alternative-article" :class="[(hasRead(alternative.slug)) ? 'did-read' : '']" v-on:click="didSelectPreviewArticle(alternative, story)">{{ alternative.name }}</p>
        </div>
    </div>
</template>

<script>
    import { Mixins } from '../mixins'
    import Status from './Status';

    export default {
        props: ['alternatives', 'story', 'stackRow'],
        mixins: [Mixins],
        components: {
            Status
        }
    }
</script>

<style lang="scss" scoped>
    @import '~styles/_variables';
    @import '../grid.scss';

    .alternative-articles {
        display: flex;
        flex-direction: column;
        margin-top: 4px;
        font-size: 12px;
        line-height: 1.4;
        margin-bottom: 0;

        &.stack-row {
            @media (min-width: 560px) {
                flex-direction: row;
            }
        }
    }

    .alternative-article-wrapper {
        display: flex;
        align-items: center;
        border-top: 1px solid $base-border;
        padding: 5px 0;

        &:last-child {
            @media (min-width: 560px) {
                padding-bottom: 0;
            }
        }

        &.stack-row {
            @media (min-width: 560px) {
                flex: 1;
                padding-right: 5px;

                &:last-child {
                    padding-bottom: 5px;
                    padding-left: 5px;
                }
            }
        }

        .alternative-article {
            font-size: 11px;
            line-height: 1.25;
            margin: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-left: 8px;

            &:hover {
                text-decoration: underline;
                cursor: pointer;
            }
        }
    }

</style>